<template>

    <v-modal title="Save New Segment">
        <template #body>
            <v-alert :message="error" />
            <form @submit.prevent="updateSegment">
                <v-form-group dir="ver" label="New Segment Name">
                    <v-input placeholder="My New Segment Name" :model="params.name" @input="params.name = $event" />
                </v-form-group>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="updateSegment">Save Segment</v-button>
        </template>
    </v-modal>

</template>

<script>

import SegmentApi from '@api/SegmentApi';

export default {

    props: {
        segment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {},
        }
    },

    methods: {

        updateSegment() {
            this.loading = true;
            this.params.new = true;
            this.params.op = this.$store.getters['segmenter/op'];
            this.params.rules = this.$store.getters['segmenter/rules'];
            SegmentApi.updateSegment(this.segment.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                    this.$router.push({ name: 'segments' });
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    }

}

</script>
